module.exports = __webpack_public_path__ + "img/vende_tu_auto_paso3_web.fe81f8cc.png";